var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBladeRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40387 6.45452C8.35824 6.38532 8.3017 6.32488 8.23701 6.2752C8.30501 6.08881 8.34076 5.89029 8.34076 5.68808C8.34076 5.45404 8.29383 5.23096 8.20887 5.02774C8.24869 4.98451 8.28389 4.93688 8.3137 4.88556L10.8385 0.277857L10.5589 0.142602C10.0179 -0.163977 8.64733 -0.082824 7.79072 1.46811L6.50128 3.7945C6.47514 3.85568 6.45742 3.91944 6.44811 3.98412C5.95766 4.03516 5.5287 4.29311 5.25008 4.66915H0V4.98475C0 5.60692 0.73038 6.78816 2.49772 6.78816H5.20283C5.23579 6.7847 5.26836 6.77915 5.30036 6.77159C5.59639 7.13376 6.03774 7.37252 6.53542 7.39888C6.54347 7.43015 6.55314 7.46106 6.5644 7.49148L9.26951 12L9.54002 11.8377C9.89709 11.5757 10.1368 11.1838 10.2073 10.7466C10.3287 10.0497 10.1769 9.33277 9.78348 8.74485L8.40387 6.45452ZM5.63565 5.68808C5.63565 5.14028 6.07972 4.6962 6.62752 4.6962C7.17532 4.6962 7.61939 5.14028 7.61939 5.68808C7.61939 6.23587 7.17532 6.67995 6.62752 6.67995C6.07972 6.67995 5.63565 6.23587 5.63565 5.68808Z",
    fill: "#EF5353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBladeRed);
export default __webpack_public_path__ + "static/media/Blade_Red.49708499c5e0881ed04dbc922dd70ad8.svg";
export { ForwardRef as ReactComponent };